const emoticonMap = {
    ":v": "😆",
    ":)": "😊",
    ":(": "☹️",
    ":D": "😄",
    ":P": "😛",
    ";)": "😉",
    ":O": "😮",
    ":*": "😘",
    ":3": "😺",
    "<3": "❤️",
    ":|": "😐",
    ":/": "😕",
    ":'(": "😢",
    "XD": "😆",
    ":S": "😖",
    "B)": "😎",
    ":$": "😳",
    ":@": "😠",
    ":#": "🤐",
    ":^)": "😏",
    ":&": "😖",
    ":')": "😂",
    ":|]": "🤖",
    ":[": "🙁",
    ":{": "😟",
    ":>": "😏",
    ":<": "😞",
    ":^*": "😚",
    ":v)": "😄",
    ":o)": "😃",
    ":c)": "😊",
    ":-)": "😊",
    ":-D": "😃",
    ":-P": "😛",
    ":-O": "😮",
    ":-*": "😘",
    ":-/": "😕",
    ":-|": "😐",
    ":-X": "🤐",
    ":-$": "😳",
    ":-@": "😠",
    ":-#": "🤐",
    ":-&": "😖",
    ":-')": "😂",
    ":-[": "🙁",
    ":-{": "😟",
    ":-<": "😞",
    ":-^*": "😚",
    ":-v)": "😄",
    ":-o)": "😃",
    ":-c)": "😊",
    ":-^)": "😊",
    ":-(": "☹️",
    ":-C": "😞",
    ":-c": "😞",
    ":-||": "😠",
    ":-!": "😖",
    ":-\\": "😕",
    ":-]": "🙂",
    ":-}": "🙂",
    ":-))": "😄",
    ":-)))": "😆",
    ":-p": "😛",
    ":-b": "😛",
    ":-Þ": "😛",
    ":-þ": "😛",
    ":-0": "😮",
    ":-x": "🤐",
    "D:": "😧",
    "QQ": "😭",
    "T_T": "😭",
    "T.T": "😭",
    "^_^": "😄",
    "^-^": "😊",
    "-_-": "😑",
    ">_<": "😣",
    "o_O": "😳",
    "O_o": "😳",
    "O_O": "😲",
    ">:)": "😈",
    ">:)": "😈",
    ">:)": "😈",
    "<:)": "😇",
    ":^)": "😏",
    ">:(": "😡",
    ":'D": "😂",
    ":'-)": "😂",
    ":')": "😂",
    ":o": "😮",
    ":0": "😮",
    ":]": "🙂",
    ":}": "🙂",
    ":@": "😡",
    ":#": "🤐",
    ":!": "😖",
    ":-'(": "😢",
    ":-'-": "😢",
    ":'|": "😥",
    ">:D": "😈",
    ":^)": "🙂",
    ":p": "😛",
    ";p": "😜",
    ";D": "😄",
    "xD": "😆",
    "XP": "😝"
};
export function replaceEmoticonsWithEmoji(text) {
    return text.replace(/:\)|:\(|:v|:D|:P|;\)|:O|:\*|:3|<3|XD|:'\(|:-?[)(DPOS*/\\x@$#!^;><\[\]{}]+/g, match => emoticonMap[match] || match);

}  